import { bool, number, string } from 'prop-types';
import React from 'react';
import ArticlesList from 'sly/resourceCenter/components/ArticlesList';
import { usePrefetch } from 'sly/services/api/prefetch';

const ArticlesListByResourceCenter = ({
  limit: _limit,
  topic,
  id,
  withRedirectToTopicPage,
  articlesTitle,
}) => {
  const { requestInfo } = usePrefetch('getArticle', {
    'filters[mainTopic][slug][$eq]': topic,
    'pagination[pageSize]': 3,
    populate: '*',
    ...(!withRedirectToTopicPage && { 'fitlers[id][$ne]': id }),
  });

  if (
    (requestInfo.hasFinished && !requestInfo?.result?.data?.length) ||
    !requestInfo.hasFinished
  )
    return null;

  return (
    <ArticlesList
      {...{
        topic,
        withRedirectToTopicPage,
        articlesTitle,
        articles: requestInfo.result.data,
      }}
    />
  );
};

ArticlesListByResourceCenter.propTypes = {
  limit: number,
  topic: string,
  id: number,
  withRedirectToTopicPage: bool,
  articlesTitle: string,
};

export default ArticlesListByResourceCenter;
